/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { governanceMetricsGetApiV3StakingMetricsName } from "../../funcs/governanceMetricsGetApiV3StakingMetricsName.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3StakingMetricsNameRequest$inboundSchema,
};

export const tool$governanceMetricsGetApiV3StakingMetricsName: ToolDefinition<
  typeof args
> = {
  name: "governance-metrics-get-api-v3-staking-metrics-name",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await governanceMetricsGetApiV3StakingMetricsName(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
